import { Box, styled } from "@mui/material";

export const ElementsBackground = styled(Box)({
  borderRadius: '16px',
  backgroundColor: '#1D1F2B',
  border: '1px solid #333A47',
  boxShadow: '0px 0px 25.6px 0px #0000007D',
  overflow: 'hidden',
})